<ng-content select="td-wb-page-header-back-button"></ng-content>
<div class="td-wb-page-header__container">
  <h1 class="td-wb-page-header__title">
    <ng-content select="td-wb-page-header-title"></ng-content>
  </h1>
  <ng-content select="td-wb-page-header-date"></ng-content>
</div>
<ng-content select="td-wb-page-header-toolbar"></ng-content>
